import { SuperAdminConstants } from '../../_constants';
import { SuperAdminService } from '../../_services';
import { homePageAction } from '../HomePage/homePage.action';

export const superAdminAction = {
    getOrgDetailsHandler,
    editOrgDetailsHandler,
    deleteOrgDetailsHandler,
    getAssessmentOrganisationHandler,
    getAnalyticsOrganisationHandler,
    addAssessmentOrganisationHandler,
    removeAssessmentOrganisationHandler,
    getAnalyticsOrgBatchesHandler,
    addAnalyticsActiveBatchesHandler,
    getAnalyticsActiveBatchesHandler,
    removeAnalyticsActiveBatchesHandler,
    getOrgAdminsHandler,
    addOrgAdminHandler,
    makeOrgPrimaryAdminHandler,
    removeOrgAdminHandler,
    getCreditsHandler,
    addCreditsHandler,
    revokeCreditsHandler,
    getMetricsListHandler,
    getAnalyticsMetricListHandler,
    changeMetricAccessHandler,
    editMetricHandler,
    deleteMetricHandler,
    assignMetricHandler,
    editAssignMetricHandler,
    deleteAssignMetricHandler,
    getSwotTextHandler,
    editSwotTextHandler,
    getFocusAreaTextHandler,
    editFocusAreaTextHandler,
    getReviewQuestionsHandler,
    editReviewQuestionsHandler,

    //assign assessor groups
    removeAssessorGroup,
    getAssessment_groupsList,
    postAssessment_groupsList,
    assessor_groupList,


    // Assign Metric and Define Levels
    dropdownListAssignMetric,
    addNewCompetency,
    editExistingCompetency,
    deleteExistingCompetency,


    //define metric list api
    defaultDefineMetricList,
    combinedMetricListApi,
    combinedAllowAccessApi,
    combinedDenyAccessApi

};

function combinedDenyAccessApi(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.combinedDenyAccessApi(id)
            .then(
                combinedDenyMetricAPI => {
                    dispatch(success(combinedDenyMetricAPI));
                    if(callback) {
                        callback(combinedDenyMetricAPI)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_COMBINED_DENY_METRIC } }
    function success(combinedDenyMetricAPI) { return { type: SuperAdminConstants.RECEIVE_COMBINED_DENY_METRIC, combinedDenyMetricAPI } }
    function failure(error) { return { type: SuperAdminConstants.COMBINED_DENY_METRIC_ERROR, error } }
}

function combinedAllowAccessApi(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.combinedAllowAccessApi(id)
            .then(
                combinedAllowMetricAPI => {
                    dispatch(success(combinedAllowMetricAPI));
                    if(callback) {
                        callback(combinedAllowMetricAPI)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_COMBINED_ALLOW_METRIC } }
    function success(combinedAllowMetricAPI) { return { type: SuperAdminConstants.RECEIVE_COMBINED_ALLOW_METRIC, combinedAllowMetricAPI } }
    function failure(error) { return { type: SuperAdminConstants.COMBINED_ALLOW_METRIC_ERROR, error } }
}

function combinedMetricListApi(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.combinedMetricListApi(id)
            .then(
                combinedMetricAPI => {
                    dispatch(success(combinedMetricAPI));
                    if(callback) {
                        callback(combinedMetricAPI)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_COMBINED_METRIC_LIST } }
    function success(combinedMetricAPI) { return { type: SuperAdminConstants.RECEIVE_COMBINED_METRIC_LIST, combinedMetricAPI } }
    function failure(error) { return { type: SuperAdminConstants.COMBINED_METRIC_LIST_ERROR, error } }
}

function defaultDefineMetricList(data, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.defaultMetricListApi(data)
            .then(
                defaultMetricAPI => {
                    dispatch(success(defaultMetricAPI));
                    if(callback) {
                        callback(defaultMetricAPI)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_DEFAULT_METRIC_LIST } }
    function success(defaultMetricAPI) { return { type: SuperAdminConstants.RECEIVE_DEFAULT_METRIC_LIST, defaultMetricAPI } }
    function failure(error) { return { type: SuperAdminConstants.DEFAULT_METRIC_LIST_ERROR, error } }
}

function deleteExistingCompetency(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.deleteExistingCompetency(id)
            .then(
                delMetricAPI => {
                    dispatch(success(delMetricAPI));
                    if(callback) {
                        callback(delMetricAPI)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_DELETE_EXISTING_METRIC } }
    function success(delMetricAPI) { return { type: SuperAdminConstants.RECEIVE_DELETE_EXISTING_METRIC, delMetricAPI } }
    function failure(error) { return { type: SuperAdminConstants.DELETE_EXISTING_METRIC_ERROR, error } }
}

function editExistingCompetency(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.editExistingCompetency(id)
            .then(
                editMetricAPI => {
                    dispatch(success(editMetricAPI));
                    if(callback) {
                        callback(editMetricAPI)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_EDIT_EXISTING_METRIC } }
    function success(editMetricAPI) { return { type: SuperAdminConstants.RECEIVE_EDIT_EXISTING_METRIC, editMetricAPI } }
    function failure(error) { return { type: SuperAdminConstants.EDIT_EXISTING_METRIC_ERROR, error } }
}

function addNewCompetency(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.addNewCompetency(id)
            .then(
                addNewMetricAPI => {
                    dispatch(success(addNewMetricAPI));
                    if(callback) {
                        callback(addNewMetricAPI)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ADD_NEW_METRIC } }
    function success(addNewMetricAPI) { return { type: SuperAdminConstants.RECEIVE_ADD_NEW_METRIC, addNewMetricAPI } }
    function failure(error) { return { type: SuperAdminConstants.ADD_NEW_METRIC_ERROR, error } }
}

function dropdownListAssignMetric(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.dropdownListAssignMetric(id)
            .then(
                metricGroupList => {
                    dispatch(success(metricGroupList));
                    if(callback) {
                        callback(metricGroupList)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ANALYTICS_DEFAULT_METRIC_LIST } }
    function success(metricGroupList) { return { type: SuperAdminConstants.RECEIVE_ANALYTICS_DEFAULT_METRIC_LIST, metricGroupList } }
    function failure(error) { return { type: SuperAdminConstants.ANALYTICS_DEFAULT_METRIC_LIST_ERROR, error } }
}

function assessor_groupList(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.assessor_groupList(id)
            .then(
                assessorGroupList => {
                    dispatch(success(assessorGroupList));
                    if(callback) {
                        callback(assessorGroupList)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ASSESSOR_GROUP_LIST_ASSIGN } }
    function success(assessorGroupList) { return { type: SuperAdminConstants.RECEIVE_ASSESSOR_GROUP_LIST_ASSIGN, assessorGroupList } }
    function failure(error) { return { type: SuperAdminConstants.ASSESSOR_GROUP_LIST_ASSIGN_ERROR, error } }
}

function postAssessment_groupsList(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.postAssessment_groupsList(id)
            .then(
                postAssessmentGroupList => {
                    dispatch(success(postAssessmentGroupList));
                    if(callback) {
                        callback(postAssessmentGroupList)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_POST_ASSESSOR_GROUP_LIST } }
    function success(postAssessmentGroupList) { return { type: SuperAdminConstants.RECEIVE_POST_ASSESSOR_GROUP_LIST, postAssessmentGroupList } }
    function failure(error) { return { type: SuperAdminConstants.POST_ASSESSOR_GROUP_LIST_ERROR, error } }
}


function getAssessment_groupsList(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getAssessment_groupsList(id)
            .then(
                getAssessmentGroupList => {
                    dispatch(success(getAssessmentGroupList));
                    if(callback) {
                        callback(getAssessmentGroupList)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_ASSESSOR_GROUP_LIST } }
    function success(getAssessmentGroupList) { return { type: SuperAdminConstants.RECEIVE_GET_ASSESSOR_GROUP_LIST, getAssessmentGroupList } }
    function failure(error) { return { type: SuperAdminConstants.GET_ASSESSOR_GROUP_LIST_ERROR, error } }
}

function removeAssessorGroup(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.removeAssessorGroup(id)
            .then(
                delAssessorGroup => {
                    dispatch(success(delAssessorGroup));
                    if(callback) {
                        callback(delAssessorGroup)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_DELETE_ASSIGN_ASSESSOR } }
    function success(delAssessorGroup) { return { type: SuperAdminConstants.RECEIVE_DELETE_ASSIGN_ASSESSOR, delAssessorGroup } }
    function failure(error) { return { type: SuperAdminConstants.DELETE_ASSIGN_ASSESSOR_ERROR, error } }
}

function getOrgDetailsHandler(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getOrgDetailsHandler(id)
            .then(
                getOrgDetails => {
                    dispatch(success(getOrgDetails));
                    callback(getOrgDetails)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_ORG_DETAILS } }
    function success(getOrgDetails) { return { type: SuperAdminConstants.RECEIVE_GET_ORG_DETAILS, getOrgDetails } }
    function failure(error) { return { type: SuperAdminConstants.GET_ORG_DETAILS_ERROR, error } }
}

function editOrgDetailsHandler(id, fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.editOrgDetailsHandler(id, fd)
            .then(
                editOrgDetails => {
                    dispatch(success(editOrgDetails));
                    callback(editOrgDetails);
                    dispatch(getOrgDetailsHandler(id, (data) => { }))
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_EDIT_ORG_DETAILS } }
    function success(editOrgDetails) { return { type: SuperAdminConstants.RECEIVE_EDIT_ORG_DETAILS, editOrgDetails } }
    function failure(error) { return { type: SuperAdminConstants.EDIT_ORG_DETAILS_ERROR, error } }
}

function deleteOrgDetailsHandler(fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.deleteOrgDetailsHandler(fd)
            .then(
                deleteOrgDetails => {
                    dispatch(success(deleteOrgDetails));
                    callback(deleteOrgDetails);
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_DELETE_ORG_DETAILS } }
    function success(deleteOrgDetails) { return { type: SuperAdminConstants.RECEIVE_DELETE_ORG_DETAILS, deleteOrgDetails } }
    function failure(error) { return { type: SuperAdminConstants.DELETE_ORG_DETAILS_ERROR, error } }
}

// Super admin org details tab ends


// Super admin add participants tab starts
function getAssessmentOrganisationHandler(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getAssessmentOrganisationHandler(id)
            .then(
                getAssessmentOrganisation => {
                    dispatch(success(getAssessmentOrganisation));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_ASSESSMENT_ORGANISATION } }
    function success(getAssessmentOrganisation) { return { type: SuperAdminConstants.RECEIVE_GET_ASSESSMENT_ORGANISATION, getAssessmentOrganisation } }
    function failure(error) { return { type: SuperAdminConstants.GET_ASSESSMENT_ORGANISATION_ERROR, error } }
}

function getAnalyticsOrganisationHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getAnalyticsOrganisationHandler()
            .then(
                analyticsOrganisation => {
                    dispatch(success(analyticsOrganisation));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_ANALYTICS_ORGANISATION } }
    function success(analyticsOrganisation) { return { type: SuperAdminConstants.RECEIVE_GET_ANALYTICS_ORGANISATION, analyticsOrganisation } }
    function failure(error) { return { type: SuperAdminConstants.GET_ANALYTICS_ORGANISATION_ERROR, error } }
}


function addAssessmentOrganisationHandler(fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.addAssessmentOrganisationHandler(fd)
            .then(
                addAssessmentOrganisation => {
                    dispatch(success(addAssessmentOrganisation));
                    dispatch(getAnalyticsOrganisationHandler(() => {
                        dispatch(getAssessmentOrganisationHandler(fd.analytics_organisation, () => {
                        }))
                    }))
                    callback(addAssessmentOrganisation);
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ADD_ASSESSMENT_ORGANISATION } }
    function success(addAssessmentOrganisation) { return { type: SuperAdminConstants.RECEIVE_ADD_ASSESSMENT_ORGANISATION, addAssessmentOrganisation } }
    function failure(error) { return { type: SuperAdminConstants.ADD_ASSESSMENT_ORGANISATION_ERROR, error } }
}

function removeAssessmentOrganisationHandler(fd, orgId, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.removeAssessmentOrganisationHandler(fd)
            .then(
                removeAssessmentOrganisation => {
                    dispatch(success(removeAssessmentOrganisation));
                    dispatch(getAnalyticsOrganisationHandler(() => {
                        dispatch(getAssessmentOrganisationHandler(orgId, () => {
                        }))
                    }))
                    const responseData = {
                        'status': removeAssessmentOrganisation.status,
                        'data': {
                            'message': removeAssessmentOrganisation.data.message[0].message
                        }
                    }
                    callback(responseData);
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_REMOVE_ASSESSMENT_ORGANISATION } }
    function success(removeAssessmentOrganisation) { return { type: SuperAdminConstants.RECEIVE_REMOVE_ASSESSMENT_ORGANISATION, removeAssessmentOrganisation } }
    function failure(error) { return { type: SuperAdminConstants.REMOVE_ASSESSMENT_ORGANISATION_ERROR, error } }
}

// Super admin add participants tab ends


// Super admin manage participants tab starts
function getAnalyticsOrgBatchesHandler(fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getAnalyticsOrgBatchesHandler(fd)
            .then(
                getAnalyticsOrgBatches => {
                    dispatch(success(getAnalyticsOrgBatches));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ANALYTICS_ORG_BATCHES } }
    function success(getAnalyticsOrgBatches) { return { type: SuperAdminConstants.RECEIVE_ANALYTICS_ORG_BATCHES, getAnalyticsOrgBatches } }
    function failure(error) { return { type: SuperAdminConstants.ANALYTICS_ORG_BATCHES_ERROR, error } }
}

function addAnalyticsActiveBatchesHandler(fd, callback) {

    return dispatch => {
        dispatch(request());
        SuperAdminService.addAnalyticsActiveBatchesHandler(fd)
            .then(
                addAnalyticsActiveBatches => {
                    dispatch(success(addAnalyticsActiveBatches));
                    dispatch(getAnalyticsOrgBatchesHandler(fd.analytics_organisation, () => {
                        dispatch(getAnalyticsActiveBatchesHandler(fd.analytics_organisation, () => {
                        }))
                    }))
                    callback(addAnalyticsActiveBatches)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ADD_ANALYTICS_ACTIVE_BATCHES } }
    function success(addAnalyticsActiveBatches) { return { type: SuperAdminConstants.RECEIVE_ADD_ANALYTICS_ACTIVE_BATCHES, addAnalyticsActiveBatches } }
    function failure(error) { return { type: SuperAdminConstants.ADD_ANALYTICS_ACTIVE_BATCHES_ERROR, error } }
}

function getAnalyticsActiveBatchesHandler(fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getAnalyticsActiveBatchesHandler(fd)
            .then(
                getAnalyticsActiveBatches => {
                    dispatch(success(getAnalyticsActiveBatches));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ANALYTICS_ACTIVE_BATCHES } }
    function success(getAnalyticsActiveBatches) { return { type: SuperAdminConstants.RECEIVE_ANALYTICS_ACTIVE_BATCHES, getAnalyticsActiveBatches } }
    function failure(error) { return { type: SuperAdminConstants.ANALYTICS_ACTIVE_BATCHES_ERROR, error } }
}

function removeAnalyticsActiveBatchesHandler(fd, orgId, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.removeAnalyticsActiveBatchesHandler(fd)
            .then(
                removeAnalyticsActiveBatches => {
                    dispatch(success(removeAnalyticsActiveBatches));
                    dispatch(getAnalyticsOrgBatchesHandler(orgId, () => {
                        dispatch(getAnalyticsActiveBatchesHandler(orgId, () => {
                        }))
                    }))
                    const responseData = {
                        'status': removeAnalyticsActiveBatches.status,
                        'data': {
                            'message': removeAnalyticsActiveBatches.data.message[0].message
                        }
                    }
                    callback(responseData)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_REMOVE_ANALYTICS_ACTIVE_BATCHES } }
    function success(removeAnalyticsActiveBatches) { return { type: SuperAdminConstants.RECEIVE_REMOVE_ANALYTICS_ACTIVE_BATCHES, removeAnalyticsActiveBatches } }
    function failure(error) { return { type: SuperAdminConstants.REMOVE_ANALYTICS_ACTIVE_BATCHES_ERROR, error } }
}
// Super admin manage participants tab ends


// Super admin manage org admins tab starts
function getOrgAdminsHandler(orgId, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getOrgAdminsHandler(orgId)
            .then(
                getOrgAdmins => {
                    dispatch(success(getOrgAdmins));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_ORG_ADMINS } }
    function success(getOrgAdmins) { return { type: SuperAdminConstants.RECEIVE_GET_ORG_ADMINS, getOrgAdmins } }
    function failure(error) { return { type: SuperAdminConstants.GET_ORG_ADMINS_ERROR, error } }
}

function addOrgAdminHandler(fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.addOrgAdminHandler(fd)
            .then(
                addOrgAdmin => {
                    dispatch(success(addOrgAdmin));
                    callback(addOrgAdmin);
                    dispatch(getOrgAdminsHandler(fd.analytics_organisation_id, () => { }))
                },
                error => {
                    dispatch(failure(error));
                    callback(error.response);
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ADD_ORG_ADMINS } }
    function success(addOrgAdmin) { return { type: SuperAdminConstants.RECEIVE_ADD_ORG_ADMINS, addOrgAdmin } }
    function failure(error) { return { type: SuperAdminConstants.ADD_ORG_ADMINS_ERROR, error } }
}

function makeOrgPrimaryAdminHandler(fd, orgId, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.makeOrgPrimaryAdminHandler(fd)
            .then(
                makeOrgPrimaryAdmin => {
                    dispatch(success(makeOrgPrimaryAdmin));
                    dispatch(getOrgAdminsHandler(orgId, () => { }))
                    callback(makeOrgPrimaryAdmin)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_MAKE_ORG_PRIMARY_ADMIN } }
    function success(makeOrgPrimaryAdmin) { return { type: SuperAdminConstants.RECEIVE_MAKE_ORG_PRIMARY_ADMIN, makeOrgPrimaryAdmin } }
    function failure(error) { return { type: SuperAdminConstants.MAKE_ORG_PRIMARY_ADMIN_ERROR, error } }
}

function removeOrgAdminHandler(fd, orgId, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.removeOrgAdminHandler(fd)
            .then(
                removeOrgAdmin => {
                    dispatch(success(removeOrgAdmin));
                    dispatch(getOrgAdminsHandler(orgId, () => { }))
                    callback(removeOrgAdmin)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_REMOVE_ORG_ADMIN } }
    function success(removeOrgAdmin) { return { type: SuperAdminConstants.RECEIVE_REMOVE_ORG_ADMIN, removeOrgAdmin } }
    function failure(error) { return { type: SuperAdminConstants.REMOVE_ORG_ADMIN_ERROR, error } }
}

// Super admin manage org admins tab ends


// Super admin manage credits tab starts
function getCreditsHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getCreditsHandler(data)
            .then(
                getCredits => {
                    dispatch(success(getCredits));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_CREDITS } }
    function success(getCredits) { return { type: SuperAdminConstants.RECEIVE_GET_CREDITS, getCredits } }
    function failure(error) { return { type: SuperAdminConstants.GET_CREDITS_ERROR, error } }
}

function addCreditsHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.addCreditsHandler(data)
            .then(
                addCredits => {
                    dispatch(success(addCredits));
                    dispatch(getCreditsHandler(data.organisation_id, () => { }));
                    callback(addCredits)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ADD_CREDITS } }
    function success(addCredits) { return { type: SuperAdminConstants.RECEIVE_ADD_CREDITS, addCredits } }
    function failure(error) { return { type: SuperAdminConstants.ADD_CREDITS_ERROR, error } }
}

function revokeCreditsHandler(data, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.revokeCreditsHandler(data)
            .then(
                revokeCredits => {
                    dispatch(success(revokeCredits));
                    dispatch(getCreditsHandler(data.organisation_id, () => { }));
                    callback(revokeCredits)
                },
                error => {
                    dispatch(failure(error));
                    callback(error.response)

                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_REVOKE_CREDITS } }
    function success(revokeCredits) { return { type: SuperAdminConstants.RECEIVE_REVOKE_CREDITS, revokeCredits } }
    function failure(error) { return { type: SuperAdminConstants.REVOKE_CREDITS_ERROR, error } }
}

// Super admin manage credits tab ends


// Super admin define metrics tab starts


function getMetricsListHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getMetricsListHandler()
            .then(
                getMetricsList => {
                    dispatch(success(getMetricsList));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_METRICS_LIST } }
    function success(getMetricsList) { return { type: SuperAdminConstants.RECEIVE_GET_METRICS_LIST, getMetricsList } }
    function failure(error) { return { type: SuperAdminConstants.GET_METRICS_LIST_ERROR, error } }
}


function getAnalyticsMetricListHandler(data,callback, type) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getAnalyticsMetricListHandler(data, type)
            .then(
                getAnalyticsMetricList => {
                    dispatch(success(getAnalyticsMetricList));
                    callback(getAnalyticsMetricList)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_ANALYTICS_METRICS_LIST } }
    function success(getAnalyticsMetricList) { return { type: SuperAdminConstants.RECEIVE_GET_ANALYTICS_METRICS_LIST, getAnalyticsMetricList } }
    function failure(error) { return { type: SuperAdminConstants.GET_ANALYTICS_METRICS_LIST_ERROR, error } }
}

function changeMetricAccessHandler(fd, type, callback){
    return dispatch => {
        dispatch(request());
        SuperAdminService.changeMetricAccessHandler(fd, type)
            .then(
                changeMetricAccess => {
                    dispatch(success(changeMetricAccess));
                    callback(changeMetricAccess,type)
                },
                error => {
                    dispatch(failure(error));
                    callback(error)
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_METRIC_CHANGE_ACCESS } }
    function success(changeMetricAccess) { return { type: SuperAdminConstants.RECEIVE_METRIC_CHANGE_ACCESS, changeMetricAccess } }
    function failure(error) { return { type: SuperAdminConstants.METRIC_CHANGE_ACCESS_ERROR, error } }
}

function editMetricHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.editMetricHandler()
            .then(
                editMetric => {
                    dispatch(success(editMetric));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_EDIT_METRICS } }
    function success(editMetric) { return { type: SuperAdminConstants.RECEIVE_EDIT_METRICS, editMetric } }
    function failure(error) { return { type: SuperAdminConstants.EDIT_METRICS_ERROR, error } }
}

function deleteMetricHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.deleteMetricHandler()
            .then(
                deleteMetric => {
                    dispatch(success(deleteMetric));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_DELETE_METRICS } }
    function success(deleteMetric) { return { type: SuperAdminConstants.RECEIVE_DELETE_METRICS, deleteMetric } }
    function failure(error) { return { type: SuperAdminConstants.DELETE_METRICS_ERROR, error } }
}

// Super admin define metrics tab ends


// Super admin Assign metrics tab starts
function assignMetricHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.assignMetricHandler()
            .then(
                assignMetric => {
                    dispatch(success(assignMetric));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_ASSIGN_METRIC } }
    function success(assignMetric) { return { type: SuperAdminConstants.RECEIVE_ASSIGN_METRIC, assignMetric } }
    function failure(error) { return { type: SuperAdminConstants.ASSIGN_METRIC_ERROR, error } }
}

function editAssignMetricHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.editAssignMetricHandler()
            .then(
                editAssignMetric => {
                    dispatch(success(editAssignMetric));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_EDIT_ASSIGN_METRICS } }
    function success(editAssignMetric) { return { type: SuperAdminConstants.RECEIVE_EDIT_ASSIGN_METRICS, editAssignMetric } }
    function failure(error) { return { type: SuperAdminConstants.EDIT_ASSIGN_METRICS_ERROR, error } }
}

function deleteAssignMetricHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.deleteAssignMetricHandler()
            .then(
                deleteAssignMetric => {
                    dispatch(success(deleteAssignMetric));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_DELETE_ASSIGN_METRICS } }
    function success(deleteAssignMetric) { return { type: SuperAdminConstants.RECEIVE_DELETE_ASSIGN_METRICS, deleteAssignMetric } }
    function failure(error) { return { type: SuperAdminConstants.DELETE_ASSIGN_METRICS_ERROR, error } }
}
// Super admin Assign metrics tab ends


// Super admin swot text tab starts
function getSwotTextHandler(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getSwotTextHandler(id)
            .then(
                getSwotText => {
                    dispatch(success(getSwotText));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_SWOT_TEXT } }
    function success(getSwotText) { return { type: SuperAdminConstants.RECEIVE_GET_SWOT_TEXT, getSwotText } }
    function failure(error) { return { type: SuperAdminConstants.GET_SWOT_TEXT_ERROR, error } }
}

function editSwotTextHandler(id, swotId, fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.editSwotTextHandler(id, fd)
            .then(
                editSwotText => {
                    dispatch(success(editSwotText));
                    dispatch(getSwotTextHandler(swotId, () => { }))
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_EDIT_SWOT_TEXT } }
    function success(editSwotText) { return { type: SuperAdminConstants.RECEIVE_EDIT_SWOT_TEXT, editSwotText } }
    function failure(error) { return { type: SuperAdminConstants.EDIT_SWOT_TEXT_ERROR, error } }
}
// Super admin swot text tab ends


// Super admin focus area text tab starts
function getFocusAreaTextHandler(callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getFocusAreaTextHandler()
            .then(
                getFocusAreaText => {
                    dispatch(success(getFocusAreaText));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_FOCUS_AREA_TEXT } }
    function success(getFocusAreaText) { return { type: SuperAdminConstants.RECEIVE_GET_FOCUS_AREA_TEXT, getFocusAreaText } }
    function failure(error) { return { type: SuperAdminConstants.GET_FOCUS_AREA_TEXT_ERROR, error } }
}

function editFocusAreaTextHandler(id, fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.editFocusAreaTextHandler(id, fd)
            .then(
                editFocusAreaText => {
                    dispatch(success(editFocusAreaText));
                    dispatch(getFocusAreaTextHandler(() => { }))
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_EDIT_FOCUS_AREA_TEXT } }
    function success(editFocusAreaText) { return { type: SuperAdminConstants.RECEIVE_EDIT_FOCUS_AREA_TEXT, editFocusAreaText } }
    function failure(error) { return { type: SuperAdminConstants.EDIT_FOCUS_AREA_TEXT_ERROR, error } }
}
// Super admin focus area text tab ends


// Super admin review questions tab starts
function getReviewQuestionsHandler(id, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.getReviewQuestionsHandler(id)
            .then(
                getReviewQuestions => {
                    dispatch(success(getReviewQuestions));
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_GET_REVIEW_QUESTIONS } }
    function success(getReviewQuestions) { return { type: SuperAdminConstants.RECEIVE_GET_REVIEW_QUESTIONS, getReviewQuestions } }
    function failure(error) { return { type: SuperAdminConstants.GET_REVIEW_QUESTIONS_ERROR, error } }
}

function editReviewQuestionsHandler(id, type, fd, callback) {
    return dispatch => {
        dispatch(request());
        SuperAdminService.editReviewQuestionsHandler(id, fd)
            .then(
                editReviewQuestions => {
                    dispatch(success(editReviewQuestions));
                    dispatch(getReviewQuestionsHandler(type, () => { }))
                    callback()
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: SuperAdminConstants.REQUEST_EDIT_REVIEW_QUESTIONS } }
    function success(editReviewQuestions) { return { type: SuperAdminConstants.RECEIVE_EDIT_REVIEW_QUESTIONS, editReviewQuestions } }
    function failure(error) { return { type: SuperAdminConstants.EDIT_REVIEW_QUESTIONS_ERROR, error } }
}
// Super admin review questions tab ends



// WEBPACK FOOTER //
// ./src/_actions/SuperAdmin/superAdmin.action.js